<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Reporte de Seguros</v-toolbar-title>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical />
                  <v-text-field filled v-model="desde" type="date" clearable label="Desde"></v-text-field><v-divider class="mx-4" vertical />
                  <v-text-field filled v-model="hasta" type="date" clearable label="Hasta"></v-text-field><v-divider class="mx-4" vertical />                
                 <v-btn dark dense @click="getDatosReporte()" outlined exact > Generar <v-icon>mdi-file</v-icon></v-btn>
              </v-toolbar-items>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical></v-divider>
                  <v-text-field
                    v-model="searcher"
                    append-icon="mdi-file-search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    max-width="200px"          
                    ></v-text-field>    
                  <v-divider vertical></v-divider>
                    <v-tooltip bottom color="#96298A">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn icon large v-bind="attrs" v-on="on" @click="exportToExcel()">
                            <v-icon>mdi-microsoft-excel</v-icon>
                        </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
              </v-toolbar-items>
          </v-toolbar>          
          <v-card-text>
              <v-data-table
              :items="datosReporte"
              :headers="headersReporte"              
              :search="searcher"
              >              
              <template v-slot:item.created_at="{ item }">
                  {{formatDate(item.created_at)}}
              </template>
              <template v-slot:item.clienteempresa="{ item }">
                  {{item.tipoguia == 'importacion' ? item.empresa_c : item.empresa_e}}
              </template>
              </v-data-table>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import utils from '../utils/utils'
const XLSX = require('xlsx')
export default {
created: function(){},
data(){
    return{
        desde: null,
        hasta: null,
        isCliente: false,
        searcher: '',
        datosReporte: [],
        headersReporte:[
            { text: "Fecha Ingreso AWB", value: "created_at", sortable: false },            
            { text: "Agente Asegurador", value: "agenteasegurador.nombre", sortable: false },            
            { text: "No Aplicación", value: "seg_no_aplicacion", sortable: false },            
            { text: "AWB Inexpress", value: "guia_interna", sortable: false },
            { text: "AWB Operador", value: "guia_proveedor", sortable: false },
            { text: "Operador", value: "proveedor", sortable: false },       
            { text: "Cliente Facturar", value: "clientefacturar.empresa", sortable: false },     
            { text: "Cliente Empresa", value: "clienteempresa", sortable: false },
            { text: "País Origen", value: "pais_e", sortable: false },
            { text: "Ciudad Origen", value: "ciudad_e", sortable: false },
            { text: "País Destino", value: "pais_c", sortable: false },
            { text: "Ciudad Destino", value: "ciudad_c", sortable: false },            
            { text: "No Piezas", value: "piezas", sortable: false },
            { text: "Peso", value: "peso", sortable: false },
            { text: "Valor Contenido", value: "seg_valor_contenido", sortable: false },
            { text: "Valor Flete Internacional", value: "seg_flete_int", sortable: false },
            { text: "Valor Flete Nacional", value: "seg_flete_nac", sortable: false },
            { text: "Valor Total", value: "seg_valor_total", sortable: false },
        ],
    }
},
methods:{
    getDatosReporte: function(){
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'reporteseguros',{
            desde: this.desde, 
            hasta: this.hasta
            }).then((result) => {
                this.datosReporte = result
            });
    },
    formatDate: function(date){
        return utils.formatDate(date)
    },
    exportToExcel: function(){
        //Map Data to new Json        
        let newJson = this.datosReporte.map(rec => {
            return{
                'Fecha Ingreso AWB' :  new Date (new Date(rec.created_at).toISOString().substring(0,10) + 'T00:00:00'),                
                "Agente Asegurador": rec.agenteasegurador != undefined ? rec.agenteasegurador.nombre : '',            
                "No Aplicación": rec.seg_no_aplicacion,            
                "AWB Inexpress": rec.guia_interna,
                "AWB Operador": rec.guia_proveedor,
                "Operador": rec.proveedor,       
                "Cliente Facturar": rec.clientefacturar != undefined ? rec.clientefacturar.empresa : '',     
                "Cliente Empresa": rec.tipoguia == 'importacion' ? rec.empresa_c : rec.empresa_e,
                "País Origen": rec.pais_e,
                "Ciudad Origen": rec.ciudad_e,
                "País Destino": rec.pais_c,
                "Ciudad Destino": rec.ciudad_c,            
                "No Piezas": rec.piezas,
                "Peso": rec.peso,
                "Valor Contenido": rec.seg_valor_contenido,
                "Valor Flete Internacional": rec.seg_flete_int,
                "Valor Flete Nacional": rec.seg_flete_nac,
                "Valor Total": rec.seg_valor_total,                
            }
        });
        let data = XLSX.utils.json_to_sheet(newJson)
        const workbook = XLSX.utils.book_new()
        const filename = 'Reporte de Seguros';
        //Fit columns
        const wscols = utils.getAutoFitColumns(newJson);
        data["!cols"] = wscols;
        
        XLSX.utils.book_append_sheet(workbook, data, filename)        
        XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
},
mounted: function(){
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
    //this.getDatosReporte();
}
}
</script>